import "./RedirectModal.css";
import Modal from "../Modal/Modal";
import Checkbox from "../Checkbox/Checkbox";
import { t, Trans } from "@lingui/macro";
export function RedirectPopupModal({
    redirectModalVisible,
    setRedirectModalVisible,
    appRedirectUrl,
    setRedirectPopupTimestamp,
    setShouldHideRedirectModal,
    shouldHideRedirectModal,
    removeRedirectPopupTimestamp,
}) {
    const onClickAgree = () => {
        if (shouldHideRedirectModal) {
            setRedirectPopupTimestamp(Date.now());
        }
    };

    return (
        <Modal
            className="RedirectModal"
            isVisible={redirectModalVisible}
            setIsVisible={setRedirectModalVisible}
            label={t`Launch App`}
        >
            <Trans>You are leaving AVT.io and will be redirected to a third party, independent website.</Trans>
            <br />
            <br />
            {/* <Trans>
        The website is a community deployed and maintained instance of the open source{" "}
        <a href="https://github.com/avt-io/avt-interface" target="_blank" rel="noopener noreferrer">
          AVT front end
        </a>{" "}
        , hosted and served on the distributed, peer-to-peer{" "}
        <a href="https://ipfs.io/" target="_blank" rel="noopener noreferrer">
          IPFS network
        </a>{" "}
        .
      </Trans> */}
            {/* <Trans>
        The website is a community deployed and maintained instance of the open source{" "}
        <a href="https://github.com/avt-io/avt-interface" target="_blank" rel="noopener noreferrer">
          AVT front end
        </a>{" "}
      </Trans> */}
            <Trans>
                The website is a community deployed and maintained instance of the open source AVT front end, hosted and served on the distributed, peer-to-peer IPFS network.
            </Trans>
            <br />
            {/* <Trans>
        Alternative links can be found in the{" "}
        <a href="https://avtio.gitbook.io/avt/app-links" target="_blank" rel="noopener noreferrer">
          docs
        </a>{" "}
        .
      </Trans> */}
            <br />
            <br />
            <Trans>
                By clicking Agree you accept the T&Cs and Referral T&Cs.
            </Trans>
            <br />
            <br />
            <div className="mb-sm">
                <Checkbox isChecked={shouldHideRedirectModal} setIsChecked={setShouldHideRedirectModal}>
                    <Trans>Don't show this message again for 30 days.</Trans>
                </Checkbox>
            </div>
            <a href={appRedirectUrl} className="App-cta Exchange-swap-button" onClick={() => onClickAgree()}>
                <Trans>Agree</Trans>
            </a>
        </Modal>
    );
}
